var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex flex-col rounded-b-sm pb-10" }, [
    _c(
      "div",
      {
        staticClass:
          "flex justify-between items-center rounded-t-sm text-black font-semibold",
      },
      [
        _vm._t("button", function () {
          return [
            _c("UiButtonMessage", {
              attrs: {
                buttonClass: "customAdd",
                buttonText: "Reset",
                textClass: "customText customOnlyText",
              },
              on: {
                click: function ($event) {
                  return _vm.$emit("click")
                },
              },
            }),
          ]
        }),
      ],
      2
    ),
    _c("div", [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }